import React from 'react'
import { ProductName } from '@vtex/butik/lib'
import { ProductSellerName } from '@/checkout-instore-legacy/components/Commons/ProductSummary/ProductName/ProductSellerName'
import { productNameLoaderStyles } from '@/checkout-instore-legacy/product/ProductPage/loaderStyles'
import get from 'lodash/get'
import { getDefaultSeller } from '@/checkout-instore-legacy/seller/utils'

const ProductPageName = ({
  product,
  sku,
}: {
  product: Product
  sku: Item | undefined
}) => {
  const selectedSkuSeller = getDefaultSeller(get(sku, 'sellers', []))
  const selectedSkuSellerId = get(selectedSkuSeller, 'id')

  return (
    <>
      <ProductName
        styles={productNameLoaderStyles}
        name={get(product, 'name')}
      />
      <div className="pt3">
        <ProductSellerName sellerId={selectedSkuSellerId} type="product-page" />
      </div>
    </>
  )
}

export default ProductPageName
